// Specializaion
import { subGroup, route, professionalMeta } from '@/helpers/routes'
import Index from './index/index'
import Form from './form/form'

const routes = [
  route('index', '/index', Index, professionalMeta(' Documentos', true, 'company')),
  route('create', '/create', Form, professionalMeta('Incluir Documentos', true, 'company'))
]

export default subGroup('/documents', routes)



// WEBPACK FOOTER //
// ./src/app/professional/company/documents/routes.js